<template>
  <div class="awards-item">
    <!-- <div class="cover-box">
      <el-image style="width: 100%;height: 100%;" :src="data.img"></el-image>
      <div class="tip">诵读</div>
    </div> -->
    <div class="content-wrap">
      <div class="title text-dot">标题：{{ data.title }}</div>
      <!-- <div class="author text-row">作者：{{ data.username }}</div> -->
      <div class="activity-name text-row text-dot">活动：{{ data.activity_name }}</div>
      <div class="date text-row">日期： {{ data.make_time }}</div>
      <div class="id">证书编号：{{ data.cert_num }}</div>
    </div>
    <div class="right-wrap flex">
      <div class="icon-wrap flex">{{ data.prize_name }}</div>
      <div class="bot-box flex">
        <div @click="preview" :href="data.blockchain_file" target="_blank" class="text">证书预览</div>
        <!-- <a   :href="test_pdf" target="_blank" class="text">证书预览</a> -->

        &nbsp;&nbsp;|&nbsp;&nbsp;
        <a :href="data.blockchain_file" download="file.pdf" target="_blank" class="text">证书下载</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { saveAs } from "file-saver";
  export default {
    name: "",
    props: {
      data: Object,
    },
    data() {
      return {
        test_pdf: "https://www.yulin365.net/attachment2/pdf/temp/20220627160001.pdf",
        // test_pdf: `https://testyinji.gaoshan.co/oss/gs2021/da560850fac3f6c347f7c91b4285a26ac68cff8be7da0d46d5b95e1115a1a100.pdf`,
      };
    },
    created() {},
    mounted() {},
    methods: {
      downloadPDF() {
        // this.$api
        //   .fetchArrayBuffer({
        //     url: this.test_pdf,
        //   })
        //   .then(res => {
        //     //
        //     let blob = new Blob([res], {
        //       type: "application/octet-stram",
        //       "content-disposition": "attachment",
        //     });
        //     let link = window.URL.createObjectURL(blob);
        //     let a = document.createElement("a");
        //     a.href = this.test_pdf;
        //     a.download = "证书.pdf";
        //     document.body.appendChild(a);
        //     a.click();
        //     document.body.removeChild(a);
        //     window.URL.revokeObjectURL(link);
        //   })
        //   .catch(err => {
        //     console.log("🚀 ~ file: AwardsItem.vue ~ line 48 ~ downloadPDF ~ err", err);
        //     //
        //   });
      },
      preview() {
        //
        this.$emit("preview", this.data.blockchain_file);
      },
    },
  };
</script>

<style scoped lang="scss">
  $font-size-base: 14px;
  $font-size-title: 16px;
  $font-size-text: 14px;
  .awards-item {
    padding: 20px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #ddd;
    .cover-box {
      width: 200px;
      height: 200px;
      border-radius: 10px;
      position: relative;
      background-color: #ddd;
      overflow: hidden;
      .tip {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        border-radius: 30px;
        background-color: rgba($color: #000000, $alpha: 0.5);
        color: #fff;
        font-size: $font-size-text;
      }
    }
    .content-wrap {
      flex: 1;
      font-size: $font-size-text;
      // padding-left: 40px;
      .title {
        font-size: $font-size-title;
        margin-bottom: 37px;
        line-height: 1.3;
        font-weight: bold;
      }
      .text-row {
        margin-bottom: 14px;
      }
    }
    .right-wrap {
      width: 200px;
      flex-direction: column;
      justify-content: space-between;
      height: 200px;
      .icon-wrap {
        background-image: url("../../../../assets/img/award_bg.png");
        background-size: contain;
        background-repeat: no-repeat;
        width: 118px;
        height: 32px;
        font-size: $font-size-base;
        color: #fff;
        text-indent: 1em;
      }
      .bot-box {
        color: #805a4d;
        .text {
          cursor: pointer;
        }
      }
      .text {
        font-size: 14px;
        text-decoration: none;
        color: #805a4d;
      }
    }
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-dot {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
</style>
